
import {defineComponent} from "vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import {UtilityHelper} from "@/helpers/UtilityHelper";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import {NVPRestService} from "@/services/rest/master/NVPRestService";
import {CustomerContext} from "@/context/CustomerContext";
import {SalvusHealthAuthentications} from "@/models/nvpair/SalvusHealthAuthentications";
import BaseModal from "@/components/UI/Bootstrap/Modal/BaseModal.vue";
import {generateDomId} from "@/helpers/functions/string";
import {default as Modal} from "bootstrap/js/dist/modal";
import InputText from "@/components/UI/InputText.vue";
import {SalvusHealthAuthentication} from "@/models/nvpair/SalvusHealthAuthentication";
import {DpNameValuePairValueRestDto} from "@/api/pharma-master-nvp/models";
import {ErrorHandlerQueue} from "@/error/ErrorHandlerQueue";
import {DpExceptionsErrorHandler} from "@/error/handlers/DpExceptionsErrorHandler";
import {AxiosErrorHandler} from "@/error/handlers/AxiosErrorHandler";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import ConfirmModal from "@/components/UI/ConfirmModal.vue";
import {useToast} from "vue-toastification";

export default defineComponent({
  name: "SalvusHealth",
  components: {
    InputText,
    BaseModal,
    AlertError2,
    BaseTitle, BaseContainer
  },
  data() {
    return {
      addModalId: generateDomId(),
      addModal: null as Modal | null,
      actionUI: UIStateDto.createWithDefaults(),
      authentications: null as SalvusHealthAuthentications | null,
      authentication: new SalvusHealthAuthentication('', ''),

      toaster: useToast(),
    };
  },
  computed: {
    UtilityHelper() {
      return UtilityHelper;
    }
  },
  mounted() {
    this.addModal = new Modal('#' + this.addModalId);
    this.reloadContent();
  },
  methods: {
    async reloadContent(): Promise<void> {
      this.actionUI
        .clearError()
        .setNotReady();

      const nvpairs = await NVPRestService.getInstance()
        .findDpNvpByName(CustomerContext.getCustomerCode(), "SALVUS_HEALTH_AUTHENTICATIONS", "CMS");

      if (nvpairs === null) {
        this.authentications = new SalvusHealthAuthentications([]);
      } else {
        this.authentications = Object.assign(new SalvusHealthAuthentications([]), JSON.parse(nvpairs.value));
      }

      this.actionUI
        .setReady();
    },
    submitData: async function(): Promise<void> {
      this.actionUI.setNotReady();

      this.addModal?.hide();

      this.authentications?.authentications.push(this.authentication);

      await this.updateNvPairs();
      await this.reloadContent();
    },
    updateNvPairs: async function (): Promise<void> {
      const dto = {} as DpNameValuePairValueRestDto;
      dto.customer_code = CustomerContext.getCustomerCode();
      dto.pharmacy_code = CustomerContext.getPharmacyCode();
      dto.value = JSON.stringify(this.authentications);

      try {
        await NVPRestService.getInstance()
          .updateDpNvpByName(
            dto,
            CustomerContext.getCustomerCode(),
            "SALVUS_HEALTH_AUTHENTICATIONS",
            "CMS"
          );
      } catch (exceptions: unknown) {
        ErrorHandlerQueue
          .create()
          .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.actionUI as UIStateDto))
          .add(AxiosErrorHandler.createWithDefaultUIStateBehavior(this.actionUI as UIStateDto))
          .catch(exceptions, true);
      }
    },
    removeItem: async function(item: SalvusHealthAuthentication): Promise<void> {
      const {reveal, onConfirm} = createConfirmDialog(ConfirmModal, {
        title: this.$t('delete'),
        body: this.$t('deleteConfirmation'),
        confirmButtonText: this.$t('delete'),
        confirmButtonClass: 'btn-danger',
      });

      onConfirm(async () => {
        this.actionUI.setNotReady();

        this.authentications?.authentications.forEach((authentication: SalvusHealthAuthentication) => {
          if (authentication.apb_number === item.apb_number) {
            this.authentications?.authentications.splice(this.authentications?.authentications.indexOf(authentication), 1);
          }
        });

        await this.updateNvPairs();

        this.toaster.success(this.$t('cms.successfullyDeleted'));

        await this.reloadContent();
      });

      await reveal();
    }
  }
});
